import React, { useEffect } from "react"
import { Row, Col, Button, Card, CardBody } from "reactstrap"
import Flatpickr from "react-flatpickr"
import { useTranslation } from "react-i18next"
import Select from "react-select"
import CustomMultiSelect from "./CustomMultiSelect"
import CustomSingleSelect from "./CustomSingleSelect"

const Filters = ({
  filters = {}, // Object to control which filters to show
  state = {}, // Current state values
  setState = () => {}, // Function to update state
  handleSearch,
  handleReset,
  // Translation function
}) => {
  const { t } = useTranslation()

  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === "Enter") {
        // Prevent default behavior if inside a textarea
        if (e.target.tagName === "TEXTAREA") return

        e.preventDefault()
        handleSearch()
      }
    }

    window.addEventListener("keydown", handleKeyDown)

    return () => {
      window.removeEventListener("keydown", handleKeyDown)
    }
  }, [handleSearch])

  return (
    <Card>
      <CardBody>
        <Row className="mb-3 common_filter_row">
          {/* Dynamic Filters */}
          {Object.entries(filters).map(([key, filter]) => {
            return (
              <Col lg={filter.colSize || 3} key={key}>
                <div className="filter_inner">
                  <label>{filter.label}</label>
                  {filter.type === "text" && (
                    <input
                      type="text"
                      placeholder={filter.placeholder || key}
                      title={filter.placeholder || key}
                      className="form-control w-100"
                      value={state[key] || ""}
                      onChange={e =>
                        setState({ ...state, [key]: e.target.value })
                      }
                    />
                  )}

                  {filter.type === "dateRange" && (
                    <Flatpickr
                      options={{ mode: "range", dateFormat: "Y-m-d" }}
                      value={state[key] || []}
                      onChange={dates => setState({ ...state, [key]: dates })}
                      placeholder={filter.placeholder || t("Select Date Range")}
                      className="form-control"
                    />
                  )}

                  {filter.type === "numberRange" && (
                    <>
                      <div className="d-flex gap-3">
                        <input
                          type="number"
                          placeholder={filter.minPlaceholder || "Min"}
                          className="form-control"
                          value={state[key]?.min}
                          onChange={e =>
                            setState({
                              ...state,
                              [key]: {
                                ...state[key],
                                min: Number(e.target.value),
                              },
                            })
                          }
                        />
                        <input
                          type="number"
                          placeholder={filter.maxPlaceholder || "Max"}
                          className="form-control"
                          value={state[key]?.max}
                          onChange={e =>
                            setState({
                              ...state,
                              [key]: {
                                ...state[key],
                                max: Number(e.target.value),
                              },
                            })
                          }
                        />
                      </div>
                    </>
                  )}

                  {filter.type === "select" &&
                    filter.multiple &&
                    Array.isArray(filter.options) && (
                  /*      <Select
                          value={
                            state[key]?.map(v =>
                              filter?.options?.find(o => o.value === v)
                            ) || []
                          }
                          isMulti={true}
                          onChange={selectedOptions => {
                            setState({
                              ...state,
                              [key]: selectedOptions?.map(
                                option => option.value
                              ),
                            })
                          }}
                          options={filter.options}
                          className={`react-select-container`}
                          placeholder={filter.placeholder}
                          closeMenuOnSelect={false}
                        />*/
                        <CustomMultiSelect
                          value={
                            state[key]?.map(v =>
                              filter?.options?.find(o => o.value === v)
                            ) || []
                          }
                          onChange={selectedOptions => {
                            setState({
                              ...state,
                              [key]: selectedOptions?.map(
                                option => option.value
                              ),
                            })
                          }}
                          options={filter.options}
                          className={`react-select-container`}
                          placeholder={filter.placeholder}
                          closeMenuOnSelect={false}
                        />
                    )}

                  {filter.type === "select" &&
                    !filter.multiple &&
                    Array.isArray(filter.options) && (
                    /*  <select
                        className="form-control"
                        value={state[key] || ""}
                        onChange={e =>
                          setState({
                            ...state,
                            [key]:
                              e.target.value === "null" ? null : e.target.value,
                          })
                        }
                      >
                        <option hidden>{filter.placeholder || "Select"}</option>
                        {filter.options.map(option => {
                          return (
                            <option
                              key={option?.value?.toString()}
                              value={option?.value ?? "null"}
                            >
                              {option.label}
                            </option>
                          )
                        })}
                      </select>*/
                        <CustomSingleSelect
                          className="form-control"
                          value={filter.options.find(opt => opt.value === state[key])}
                          onChange={selected =>
                            setState({
                              ...state,
                              [key]: selected?.value ?? null,
                            })
                          }
                          options={filter.options}
                          placeholder={filter.placeholder || "Select"}
                          isClearable
                        />
                    )}
                </div>
              </Col>
            )
          })}

          {/* Search & Reset Buttons */}
          <Col lg={3}>
            <div className="filter_inner h-100" style={{ marginTop: 38 }}>
              <div className="d-flex gap-3" >
                <Button color="primary" className="w-50" onClick={handleSearch}>
                  {t("Search")}
                </Button>
                <Button
                  color="secondary"
                  className="w-50"
                  onClick={handleReset}
                >
                  {t("Reset")}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

export default Filters
